// src/jira/workspace/types.ts
var JiraWorkspaceAriResourceOwner = "jira", JiraWorkspaceAriResourceType = "workspace";

export {
  JiraWorkspaceAriResourceOwner,
  JiraWorkspaceAriResourceType
};
